"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiftLayout = void 0;
var GameVars_1 = require("./../../../GameVars");
var Utils_1 = require("../../../utils/Utils");
var BoardManager_1 = require("../BoardManager");
var GiftLayout = /** @class */ (function (_super) {
    __extends(GiftLayout, _super);
    function GiftLayout(scene) {
        var _this = _super.call(this, scene) || this;
        _this.y = -150;
        var layout = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "layout_gift_shop");
        layout.setInteractive();
        _this.add(layout);
        var gift = new Phaser.GameObjects.Image(_this.scene, -130, 0, "texture_atlas_1", "locked_gift_cake");
        _this.add(gift);
        _this.text = new Phaser.GameObjects.Text(_this.scene, 12, 0, GameVars_1.GameVars.gameText[GameVars_1.GameVars.language].UNLOCK_AT_LVL_5, { fontFamily: "Baloo", fontSize: "30px", color: "#FFD445", align: "center" });
        _this.text.setOrigin(.5);
        _this.text.setWordWrapWidth(200);
        _this.text.setStroke("#703E25", 8);
        _this.add(_this.text);
        _this.buyButton = new Utils_1.Button(_this.scene, 150, -2, "texture_atlas_1", "btn_buy_off", "btn_buy_on");
        _this.buyButton.onDown(_this.onClickBuy, _this);
        _this.add(_this.buyButton);
        if (GameVars_1.GameVars.modeGameData.stars < 4) {
            _this.buyButton.setAlpha(.2);
            _this.buyButton.input.enabled = false;
        }
        return _this;
    }
    GiftLayout.prototype.update = function () {
        if (GameVars_1.GameVars.modeGameData.stars < 4) {
            return;
        }
        if (GameVars_1.GameVars.modeGameData.timeLastGift + 7200 > Date.now() / 1000) {
            var s = Math.round(7200 - (Date.now() / 1000 - GameVars_1.GameVars.modeGameData.timeLastGift));
            this.text.text = (new Date(s * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];
            this.buyButton.setAlpha(.2);
            this.buyButton.input.enabled = false;
        }
        else {
            this.buyButton.setAlpha(1);
            this.buyButton.input.enabled = true;
            this.text.text = GameVars_1.GameVars.gameText[GameVars_1.GameVars.language].GIFT_SWEET;
        }
    };
    GiftLayout.prototype.onClickBuy = function () {
        BoardManager_1.BoardManager.onGiftClaimed();
    };
    return GiftLayout;
}(Phaser.GameObjects.Container));
exports.GiftLayout = GiftLayout;
